if (BSS_B2B) {
  if (
    window.location.pathname.includes("/pages/") ||
    window.location.pathname.includes("/account/register")
  ) {
    setTimeout(() => {
      // Default field
      const formVertical = document.querySelector(".form-vertical");
      if (formVertical) {
        formVertical.classList.add("customer");
        const lstField = document.querySelectorAll(".form-vertical .field");
        lstField.forEach((item) => {
          const labelItem = item.querySelector("label");
          const inputItem = item.querySelector("input");
          if (labelItem && inputItem) {
            inputItem.insertAdjacentElement("afterend", labelItem);
            inputItem.placeholder = " ";
          }
        });
      }

      // Field text
      document
        .querySelectorAll(
          "form[action='/account'] .form-group:not(.field-country-field, .field-accepts-marketing, .formbuilder-checkbox-group, .formbuilder-radio-group)"
        )
        .forEach((item) => {
          item.classList.add("field");
          const input = item.querySelector("input");
          const label = item.querySelector("label");
          const select = item.querySelector("select");
          const textarea = item.querySelector("textarea");
          if ((input || select || textarea) && label) {
            if (input) {
              input.placeholder = " ";
              input.insertAdjacentElement("afterend", label);
            }
            if (select) {
              select.insertAdjacentElement("afterend", label);
            }
            if (textarea) {
              textarea.insertAdjacentElement("afterend", label);
            }
          }
        });

      // Country field
      const countryField = document.querySelector(
        ".formbuilder-autocomplete.form-group.field-country-field"
      );
      if (countryField) {
        countryField.classList.add("field");
        const countryChildren = countryField.children;
        if (countryChildren) {
          countryChildren[1].placeholder = " ";
          countryChildren[2].placeholder = " ";
          countryChildren[2].style.display = "none";
          countryChildren[2].setAttribute("type", "text");
          countryChildren[3].style.top = "50px";
          countryChildren[3].insertAdjacentElement(
            "afterend",
            countryChildren[0]
          );
        }
      }
    }, 100);
  }
}

console.log(12345)
setTimeout(() => {
  const fields = document.querySelectorAll('#bss-b2b-register-form .bss-b2b-rf-field');

  fields.forEach((field) => {
    const label = field.querySelector("label");
    const inputWrapper = field.querySelector(".password-input");
    const input = inputWrapper ? inputWrapper.querySelector("input") : field.querySelector("input");
    if (inputWrapper) {
      console.log(inputWrapper)
      if (label && input) {
        console.log(input)
        inputWrapper.insertBefore(label, inputWrapper.firstChild.nextSibling); 
        inputWrapper.insertBefore(input, label);  
      }
    } else {
      if (label && input) {
        field.insertBefore(label, input.nextSibling);  
      }
    }
  });
}, 1000);
